type FirmwareToastType = 'success' | 'failure';

const FW_TOAST_SUCCESS_SEEN_KEY = 'sc-fw-toast-seen-success';
const FW_TOAST_FAILURE_SEEN_KEY = 'sc-fw-toast-seen-failure';

function normalizeVersion(firmwareVersion: string | null): string {
  return firmwareVersion?.trim() || 'unknown';
}

function getStorageKey(type: FirmwareToastType): string {
  return type === 'success' ? FW_TOAST_SUCCESS_SEEN_KEY : FW_TOAST_FAILURE_SEEN_KEY;
}

export function hasSeenFirmwareToast(type: FirmwareToastType, firmwareVersion: string | null): boolean {
  if (typeof window === 'undefined') return false;

  try {
    return window.localStorage.getItem(getStorageKey(type)) === normalizeVersion(firmwareVersion);
  } catch {
    return false;
  }
}

export function markFirmwareToastSeen(type: FirmwareToastType, firmwareVersion: string | null): void {
  if (typeof window === 'undefined') return;

  try {
    window.localStorage.setItem(getStorageKey(type), normalizeVersion(firmwareVersion));
  } catch {
    // Ignore storage failures (private mode / denied access).
  }
}

export function clearSeenFirmwareToasts(): void {
  if (typeof window === 'undefined') return;

  try {
    window.localStorage.removeItem(FW_TOAST_SUCCESS_SEEN_KEY);
    window.localStorage.removeItem(FW_TOAST_FAILURE_SEEN_KEY);
  } catch {
    // Ignore storage failures (private mode / denied access).
  }
}
